import { clearSuggestionWithAnalytics, insertInlineSuggestionWithAnalytics, fireNewSuggestionAnalytics } from './commands/commands-with-analytics';
import { SuggestionManager } from './handlers/suggestion-manager';
import { getPluginState as getInlineSuggestionState } from './plugin-factory';
export function docHasChanged(prevState, newState) {
  return !prevState.doc.eq(newState.doc);
}
export function localeHasChanged(state, currentLocale) {
  return getInlineSuggestionState(state).locale !== currentLocale;
}
export var KeydownActionType = /*#__PURE__*/function (KeydownActionType) {
  KeydownActionType["INSERT"] = "INSERT";
  KeydownActionType["DISMISS"] = "DISMISS";
  return KeydownActionType;
}({});
export var createKeyHander = function createKeyHander(actionType, triggeredFrom, api) {
  return function (state, dispatch) {
    if (getInlineSuggestionState(state).inlineSuggestion) {
      if (actionType === KeydownActionType.INSERT) {
        var _api$analytics;
        insertInlineSuggestionWithAnalytics(api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions)(triggeredFrom)(state, dispatch);
        return true;
      }
      if (actionType === KeydownActionType.DISMISS) {
        var _api$analytics2;
        clearSuggestionWithAnalytics(api === null || api === void 0 || (_api$analytics2 = api.analytics) === null || _api$analytics2 === void 0 ? void 0 : _api$analytics2.actions)(triggeredFrom)(state, dispatch);
        return true;
      }
    }
    return false;
  };
};
export var fireAnalyticsForNewInlineSuggestionShown = function fireAnalyticsForNewInlineSuggestionShown(oldState, newState, api) {
  var _getInlineSuggestionS = getInlineSuggestionState(oldState),
    oldInlineSuggestions = _getInlineSuggestionS.inlineSuggestion;
  var _getInlineSuggestionS2 = getInlineSuggestionState(newState),
    newInlineSuggestions = _getInlineSuggestionS2.inlineSuggestion;
  if ((oldInlineSuggestions === null || oldInlineSuggestions === void 0 ? void 0 : oldInlineSuggestions.metadata) !== (newInlineSuggestions === null || newInlineSuggestions === void 0 ? void 0 : newInlineSuggestions.metadata) && newInlineSuggestions !== null) {
    var _api$analytics3;
    fireNewSuggestionAnalytics({
      analyticsApi: api === null || api === void 0 || (_api$analytics3 = api.analytics) === null || _api$analytics3 === void 0 ? void 0 : _api$analytics3.actions,
      state: newState
    });
  }
  return null;
};
export function isFocusTransitioningToPopup(event) {
  var relatedTarget = event.relatedTarget || document.activeElement;
  return relatedTarget instanceof Element && Boolean(relatedTarget.closest('[data-editor-popup="true"]'));
}
export function hasActiveSuggestion(state) {
  var _getInlineSuggestionS3 = getInlineSuggestionState(state),
    inlineSuggestion = _getInlineSuggestionS3.inlineSuggestion;
  return Boolean(inlineSuggestion);
}
function isSelectionAtEndOfDocument(state) {
  return state.selection.from === state.doc.nodeSize - 3;
}
function hasActiveCompletionHintDecoration(decorationSet) {
  return decorationSet.find().some(function (deco) {
    var _deco$spec;
    return (deco === null || deco === void 0 || (_deco$spec = deco.spec) === null || _deco$spec === void 0 ? void 0 : _deco$spec.type) === SuggestionManager.DECORATION_TYPES.completionHint;
  });
}
function isAtCompletionHintBoundary(selection, inlineSuggestion) {
  return selection.from === (inlineSuggestion === null || inlineSuggestion === void 0 ? void 0 : inlineSuggestion.to);
}
export function shouldInterceptRightArrowAtDocEnd(state) {
  var selection = state.selection;
  if (!selection.empty || !isSelectionAtEndOfDocument(state)) {
    return false;
  }
  var _getInlineSuggestionS4 = getInlineSuggestionState(state),
    inlineSuggestion = _getInlineSuggestionS4.inlineSuggestion,
    decorationSet = _getInlineSuggestionS4.decorationSet;
  var hintActive = hasActiveCompletionHintDecoration(decorationSet);
  return hintActive && isAtCompletionHintBoundary(selection, inlineSuggestion);
}